/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import {
  ErrorResponse,
  ImportSkuPotentialDebugTriggerRequest,
  PreComputePotentialTriggerRequest,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';
export class Triggers<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags Triggers
   * @name PostTriggerPreComputePotential
   * @request POST:/Triggers/PreComputePotential
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  postTriggerPreComputePotential = (
    data: PreComputePotentialTriggerRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Triggers/PreComputePotential`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Triggers
   * @name PostTriggerImportSkuPotentialDebug
   * @request POST:/Triggers/ImportSkuPotentialDebug
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  postTriggerImportSkuPotentialDebug = (
    data: ImportSkuPotentialDebugTriggerRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/Triggers/ImportSkuPotentialDebug`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
